class VideoWithTextMedia extends HTMLElement {
  #observer = null;
  #mutationObserver = null;

  connectedCallback() {
    if (this.dataset.autoplay === 'true') {
      this.#setupObserver(true);
    } else {
      this.#mutationObserver = new MutationObserver(() => {
        const video = this.querySelector('video');
        const media = video || this.querySelector('iframe');
        if (!media) return;
        this.#mutationObserver.disconnect();
        this.#mutationObserver = null;
        this.#setupObserver(false);
        if (video && !video.controls) {
          this.#setupClickToggle(video);
        }
      });
      this.#mutationObserver.observe(this, { childList: true, subtree: true });
    }
  }

  #setupObserver(autoplay) {
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            if (autoplay) this.#play();
          } else {
            this.#pause();
          }
        }
      },
      { threshold: 0.5 }
    );
    this.#observer.observe(this);
  }

  #setupClickToggle(video) {
    const posterBtn = this.querySelector('.deferred-media__poster-button');
    const iconHTML = posterBtn?.innerHTML || '';

    let overlay = null;

    const showOverlay = () => {
      if (!overlay) {
        overlay = document.createElement('button');
        overlay.type = 'button';
        overlay.setAttribute('aria-label', posterBtn?.getAttribute('aria-label') || 'Play video');
        overlay.className = 'video-with-text__play-overlay';
        overlay.innerHTML = iconHTML;
        overlay.addEventListener('click', (e) => { e.stopPropagation(); video.play(); });
        this.appendChild(overlay);
      }
      overlay.hidden = false;
    };

    const hideOverlay = () => { if (overlay) overlay.hidden = true; };

    video.addEventListener('pause', showOverlay);
    video.addEventListener('ended', showOverlay);
    video.addEventListener('play', hideOverlay);
    video.addEventListener('click', () => {
      if (video.paused) video.play();
      else video.pause();
    });
  }

  #play() {
    const video = this.querySelector('video');
    if (video) {
      video.play().catch(() => {});
      return;
    }
    const iframe = this.querySelector('iframe');
    if (!iframe) return;
    if (!iframe.src) {
      iframe.src = iframe.dataset.src;
    } else {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        'https://www.youtube.com'
      );
    }
  }

  #pause() {
    const video = this.querySelector('video');
    if (video) {
      video.pause();
      return;
    }
    const iframe = this.querySelector('iframe');
    if (iframe?.src) {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        'https://www.youtube.com'
      );
    }
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#mutationObserver?.disconnect();
  }
}

if (!customElements.get('video-with-text-media')) {
  customElements.define('video-with-text-media', VideoWithTextMedia);
}